/*
* @ngdoc Component
* @name app.vehicle.vehicle.VehicleListComponent
* @description
* This component is used to manage the vehicle listing
* */

import { Component, OnInit, OnDestroy, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { CommonService } from 'src/app/services/common.service';
import { VehicleService } from 'src/app/services/vehicle.service';
import { Subscription } from 'rxjs';
import { DataStoreService } from '../../../services/data-store.service';
import { ActivatedRoute, Router, NavigationStart, Event, NavigationEnd } from '@angular/router';

@Component({
  selector: 'vehicle-list',
  templateUrl: './vehicle-list.component.html',
  styleUrls: ['./vehicle-list.component.scss']
})
export class VehicleListComponent implements OnInit, OnDestroy, OnChanges {

  @Input() isAdmin: boolean;
  @Input() routeName: string;
  @Input() resetAndSearch: Boolean;
  @Input() isBiFilter: boolean = false;
  @Output() listLoaded = new EventEmitter();
  @Output() sendError = new EventEmitter();

  isLoadingList: boolean = false;
  isPaging: boolean = false;
  vehicleList = [];

  vSubscription: Subscription
  vSubscriptionDel: Subscription
  paramsSubscription: Subscription
  requestSubscription: Subscription
  checkResetVehicleList: Subscription
  checkLoadingVehicleList: Subscription
  getSelectedFilters: Subscription

  resetRVHistorySubscription: Subscription
  capturedVehicleSubscription: Subscription
  total = 0
  currentTotal = 0
  page: any = 1
  limit = 10;
  selectedFilter = {}
  sort = 'asc'
  sortBy = 'new_price'
  throttle = 300;
  scrollDistance = 0.5;
  scrollUpDistance = 1;
  direction = 'down';
  disableScroll = true;
  noMoreRec = false;

  preventClose = null

  //loaderKey: string = ""

  constructor(private router: Router,
    private route: ActivatedRoute, private commonService: CommonService, private vehicleService: VehicleService, private dataStore: DataStoreService, private activatedRoute: ActivatedRoute) {

    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        //console.log('NavigationStart')
        if (!location.pathname.includes('vehicle-list-new') && !location.pathname.includes('vehicle-list-used')) {
          //console.log('vSubscription')
          if (this.vSubscription != null) {
            //console.log('unsubscribe')
            this.vSubscription.unsubscribe();
            //console.log('vSubscription123')
          }
        }
      }

      if (event instanceof NavigationEnd) {
        //console.log('NavigationEnd')
        this.getSelectedFilters = this.dataStore.getSelectedFilters().subscribe(data => {
          //console.log('vehicle listing', data)
          this.selectedFilter = data.filters;
        })

        this.paramsSubscription = this.activatedRoute
          .queryParams
          .subscribe(params => {
            let sort = params['sort'] || "";
            if (sort != 'asc' && sort != 'desc') {
              this.sort = 'asc'
            } else {
              this.sort = sort
            }
            let sortBy = params['sortBy'] || "";
            if (sortBy != 'new_price' && sortBy != 'units') {
              this.sortBy = 'new_price'
            } else {
              this.sortBy = sortBy
            }

            // on page load get vehicle listing
            //this.getVehicleList();
          });

        this.checkLoadingVehicleList = this.dataStore.checkLoadingVehicleList().subscribe(data => {
          this.page = 1
          this.limit = 10;
          //console.log('loading list initially')
          if (data['type'] == 'list') {
            this.getVehicleList();
          }
        })

        this.checkResetVehicleList = this.dataStore.checkResetVehicleList().subscribe(data => {
          this.resetPaginationRecords();
        })
        this.paramsSubscription.unsubscribe()
      }
    });

    // reset vehicle listing array because user click on search button
    if (this.resetAndSearch == true) {
      // cancel exiting request
      if (this.vSubscription != null) {
        //console.log('unsubscribe')
        this.vSubscription.unsubscribe();
      }
      this.isLoadingList = false;
      this.vehicleList = []
      this.disableScroll = true;
      this.page = 1
      this.limit = 10;
      this.getVehicleList()
    }

    this.resetRVHistorySubscription = this.dataStore.checkVehicleDetailsReload().subscribe((data) => {
      //console.log(data, 'data')
      if (data['cancel'] == true && data['reset'] == true && data['DatiumAssetKey']) {
        this.getVehicleDetails(data['DatiumAssetKey']);
      }
    });
  }

  getVehicleDetails(DatiumAssetKey) {
    if (this.vSubscriptionDel != null) {
      this.vSubscriptionDel.unsubscribe();
    }
    //this.loaderKey = DatiumAssetKey
    this.dataStore.setVeLoader(DatiumAssetKey, true, "Fetching the latest changes...")
    //this.commonService.showSnakeBar('Please wait while we are fetching the latest changes.');
    //console.log('getVehicleDetails', DatiumAssetKey)
    this.vSubscriptionDel = this.vehicleService.getVehicleDetail(DatiumAssetKey).subscribe(
      (result: any) => {
        try {
          this.dataStore.setVeLoader(DatiumAssetKey, false)
          //this.loaderKey = ""
          let response = result;
          let vehicle = response.data;
          if (vehicle) {
            const indexDt = this.vehicleList.findIndex(obj => obj.DatiumAssetKey == DatiumAssetKey)
            if (indexDt != -1) {
              console.log('vehicle', vehicle)
              this.preventClose = DatiumAssetKey;
              this.vehicleList[indexDt] = vehicle;
            }
          }
        } catch (e) {

        }
      },
      (error) => {
        this.dataStore.setVeLoader(DatiumAssetKey, false)
        //this.loaderKey = ""
        let response = error;
        if (response.message) {
          this.commonService.showSnakeBar(response.message);
        } else {
          this.commonService.commonSnakeBar();
        }
      },
      () => {
        this.commonService.showSnakeBar('Data has reloaded successfully.');
      }
    )
  }

  ngOnChanges(changes) {
    // Reset vehicle listing array because user click on search button
    //console.log('changes.resetAndSearch', changes.resetAndSearch)
    if (changes.resetAndSearch.currentValue === true) {
      // cancel exiting request
      if (this.vSubscription != null) {
        // console.log('unsubscribe')
        this.vSubscription.unsubscribe();
      }
      this.vehicleList = []
      //this.disableScroll = true;
      this.page = 1
      this.limit = 10;
      //console.log(this.page, 'page')
      this.getVehicleList()
    } else {
      ///this.isLoadingList = false;
    }
  }

  ngOnInit() {
  }

  /*
  * @name resetPaginationRecords
  * @param None
  * @description reset pagination, records and selected filter
  * @return none
  */
  resetPaginationRecords() {
    this.page = 1
    this.limit = 10
    this.total = 0
    this.currentTotal = 0
    this.selectedFilter = {}
    this.vehicleList = [];
    this.sort = 'asc'
    this.sortBy = 'new_price'
    //this.disableScroll = true;
    this.noMoreRec = false;
    this.isPaging = false;
  }

  toggleLoader(show = false, paging = false) {
    if (paging == false) {
      this.isLoadingList = show
    } else {
      this.isPaging = show;
    }
  }

  /*
  * @name getVehicleList
  * @param None
  * @description Api call for fetching the vehicle list
  * @return none
  */
  getVehicleList(paging = false) {
    //this.disableScroll = false;
    if (paging == false) {
      this.dataStore.setSelectedCarData({ clear: true });
      this.commonService.clearCarSelectionLength()
      this.commonService.clearNewVehicleSelectionLength()
    }
    let apiParams = {
      page: this.page,
      limit: this.limit,
      sort: this.sort,
      sortBy: this.sortBy,
      //list_type: (this.routeName == 'vehicle-list-new') ? 'new_list' : 'old_list'
    }
    if (location.pathname.includes('vehicle-list-used')) {
      apiParams['list_type'] = 'old_list'
    }
    else if (location.pathname.includes('vehicle-list-new')) {
      apiParams['list_type'] = 'new_list'
    }
    apiParams = Object.assign(apiParams, this.selectedFilter)
    //console.log('listing params', apiParams)
    setTimeout(() => {
      if (this.routeName) {
        this.router.navigate([location.pathname], { relativeTo: this.route, queryParams: apiParams, replaceUrl: true })
      }
    })
    //this.commonService.sendUserTo('vehicle-list', apiParams)
    // cancel previous request
    if (this.vSubscription != null) {
      //console.log('unsubscribe')
      this.vSubscription.unsubscribe();
    }
    this.toggleLoader(true, paging)
    this.vSubscription = this.vehicleService.getVehicleListing(apiParams).subscribe(
      (result: any) => {
        try {
          let response = result;
          let vehicleData = response.data;
          if (this.page == 1) {
            this.total = vehicleData.total
          }
          this.currentTotal = vehicleData.total;
          this.limit = vehicleData.limit
          this.page = vehicleData.page
          //console.log(this.vehicleList.length)
          if (vehicleData.records.length == 0 && paging === true) {
            this.noMoreRec = true;
          } else {
            this.noMoreRec = false;
          }
          if (vehicleData.records.length > 0) {
            this.appendVehicleListing(vehicleData.records)
            //this.vehicleList = vehicleData.records
          }
          // let's know the wrapper parent component, that list is loaded successfully
          this.listLoaded.emit(true)
          ///console.log(this.vehicleList.length)
        } catch (e) {

        }
      },
      (error) => {
        //console.log(error)
        let response = error;
        this.toggleLoader(false, paging)
        if (response.message) {
          this.handleServerFormError(response.errors)
          this.commonService.showSnakeBar(response.message);
        } else {
          this.commonService.commonSnakeBar();
        }
        this.listLoaded.emit(false)
      },
      () => {
        this.toggleLoader(false, paging)
      }
    )
  }


  /*
  * @name onScroll
  * @param newList:None
  * @description paginate on scroll
  * @return none
  */
  onScroll() {
    /*if (this.disableScroll === true) {
      return false;
    }*/
    if (this.isLoadingList === true || this.isPaging === true) {
      return false;
    }
    //console.log(typeof (this.page), 'this.page')
    let page = parseInt(this.page);
    this.page = page + 1;
    //console.log(typeof (this.page), 'this.page')
    if (this.currentTotal > 10) {
      //console.log('onScroll request')
      this.getVehicleList(true)
    }
  }

  /*
  * @name orderBy
  * @param None
  * @description handle order by records                   
  * @return none
  */
  orderBy(sortBy = 'new_price', sort = 'asc') {
    this.resetPaginationRecords()
    if (sortBy != 'new_price' && sortBy != 'units') {
      this.sortBy = 'new_price'
    } else {
      this.sortBy = sortBy
    }
    if (sort != 'asc' && sort != 'desc') {
      this.sort = 'asc'
    } else {
      this.sort = sort
    }
    //this.page = 1
    //this.limit = 10;
    //this.vehicleList = []
    //console.log('loading list initially')
    this.getVehicleList();
  }

  /*
  * @name appendVehicleListing
  * @param newList:Array
  * @description paginate over vehicle listing                   
  * @return none
  */
  appendVehicleListing(newList = []) {
    if (newList.length > 0) {
      let newState = [];
      if (this.vehicleList.length > 0) {
        newState = this.vehicleList.slice();
      }
      newList.forEach(element => {
        newState.push(element)
      });
      this.vehicleList = newState
    }

  }

  /*
  * @name formValidate
  * @param  Form
  * @description validate form                       
  * @return none
  */
  formValidate(formGroup: UntypedFormGroup) {
    /*Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.formValidate(control);
      }
    });*/
  }

  /*
  * @name handleServerFormError
  * @param Form
  * @description handle server side errors                  
  * @return none
  */
  handleServerFormError(errors) {
    if (Object.keys(errors).length > 0) {
      this.sendError.emit(errors)
    } else {
      this.sendError.emit({})
    }
    /*if (Object.keys(errors).length > 0) {
      Object.keys(errors).forEach((key) => {
        if (this.loginForm.contains(key)) {
          let control = this.loginForm.get(key);
          control.markAsTouched({ onlySelf: true });
          control.setErrors({ 'incorrect': true })
          this.formError[key] = errors[key];
        }
      });
    }*/
  }

  ngOnDestroy() {
    if (this.vSubscription) {
      this.vSubscription.unsubscribe()
    }
    if (this.vSubscriptionDel) {
      this.vSubscriptionDel.unsubscribe()
    }
    if (this.checkLoadingVehicleList) {
      this.checkLoadingVehicleList.unsubscribe()
    }
    if (this.checkResetVehicleList) {
      this.checkResetVehicleList.unsubscribe()
    }
    if (this.getSelectedFilters) {
      this.getSelectedFilters.unsubscribe()
    }
    if (this.resetRVHistorySubscription) {
      this.resetRVHistorySubscription.unsubscribe()
    }
    if (this.paramsSubscription) {
      this.paramsSubscription.unsubscribe()
    }
    if (this.capturedVehicleSubscription) {
      this.capturedVehicleSubscription.unsubscribe()
    }
  }

}
